import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
} from "react-admin";
export const UserGroupShow = props => (
  <Show title="User Group Details" {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="Group ID" />
      <TextField source="group_name" label="Group" />
      <TextField source="description" />
      <TextField source="users" />
    </SimpleShowLayout>
  </Show>
);
